module.exports = {
      id: "close_small-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#close_small",
      toString: function () {
        return this.url;
      }
    }